import { render, staticRenderFns } from "./page404.vue?vue&type=template&id=5cbbeedc&scoped=true&"
import script from "./page404.vue?vue&type=script&lang=js&"
export * from "./page404.vue?vue&type=script&lang=js&"
import style0 from "./page404.vue?vue&type=style&index=0&id=5cbbeedc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbbeedc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cbbeedc')) {
      api.createRecord('5cbbeedc', component.options)
    } else {
      api.reload('5cbbeedc', component.options)
    }
    module.hot.accept("./page404.vue?vue&type=template&id=5cbbeedc&scoped=true&", function () {
      api.rerender('5cbbeedc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/error_page/page404.vue"
export default component.exports